<template>
  <permissions-view
    :site="site"
    :section="section"
  >
    <v-container>
      <v-form v-model="valid">
        <v-row>
          <v-col cols="3">
            <responsible-person-construction
              :readonly="isReadOnly()"
              label="Responsible person, Construction"
              :value="getValue(construction, 'responsible_person')"
              @input="setValue(construction, 'responsible_person', $event)"
            />
          </v-col>
          <v-col cols="3">
            <display-field
              label="Responsible person, Radio"
            >
              {{ location.responsible_person_radio_name|noDataAvailable }}
            </display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Responsible person, Aqusition"
            >
              Data not available
            </display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Responsible person, Transmision"
            >
              {{ location.responsible_person_transmision_name|noDataAvailable }}
            </display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Kick-off"
              :value="getValue(construction, 'kick_off')"
              @input="setValue(construction, 'kick_off', $event)"
            />
          </v-col>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Cost authorisation date"
              :value="getValue(construction, 'cost_authorisation_date')"
              @input="setValue(construction, 'cost_authorisation_date', $event)"
            />
          </v-col>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Civil Works start date"
              :value="getValue(construction, 'civil_works_start_date')"
              @input="setValue(construction, 'civil_works_start_date', $event)"
            />
          </v-col>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Civil Works end date"
              :value="getValue(construction, 'civil_works_end_date')"
              @input="setValue(construction, 'civil_works_end_date', $event)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Dismantling completed"
              :value="getValue(construction, 'dismantling_completed')"
              @input="setValue(construction, 'dismantling_completed', $event)"
            />
          </v-col>
          <v-col cols="3">
            <c-w-subcontractor
              :readonly="isReadOnly()"
              label="CW Subcontractor"
              :value="getValue(construction, 'cw_subcontractor')"
              @input="setValue(construction, 'cw_subcontractor', $event)"
            ></c-w-subcontractor>
          </v-col>
          <v-col cols="3">
            <c-w-supervisor
              :readonly="isReadOnly()"
              label="CW Supervisor"
              :value="getValue(construction, 'cw_supervisor')"
              @input="setValue(construction, 'cw_supervisor', $event)"
            ></c-w-supervisor>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <switch-button
              :readonly="isReadOnly()"
              label="Invoicing needed"
              :value="getValue(construction, 'invoicing_needed')"
              @change="setValue(construction, 'invoicing_needed', $event)"
            >
          </switch-button>
          </v-col>
          <v-col cols="3">
            <construction-type
              :readonly="isReadOnly()"
              label="Construction type"
              :value="getValue(construction, 'construction_type')"
              @input="setValue(construction, 'construction_type', $event)"
            ></construction-type>
          </v-col>
          <v-col cols="3">
            <construction-subtype
              :readonly="isReadOnly()"
              label="Construction subtype"
              :value="getValue(construction, 'construction_subtype')"
              @input="setValue(construction, 'construction_subtype', $event)"
            ></construction-subtype>
          </v-col>
          <v-col cols="3">
            <equipment-space-type
              :readonly="isReadOnly()"
              label="Equipment space type"
              :value="getValue(construction, 'equipment_space_type')"
              @input="setValue(construction, 'equipment_space_type', $event)"
            ></equipment-space-type>
          </v-col>
          <v-col cols="3">
            <equipment-space-subtype
              :readonly="isReadOnly()"
              label="Equipment space Subtype"
              :value="getValue(construction, 'equipment_space_subtype')"
              @input="setValue(construction, 'equipment_space_subtype', $event)"
            ></equipment-space-subtype>
          </v-col>
          <v-col cols="3">
            <cooling-type
              :readonly="isReadOnly()"
              label="Cooling type"
              :value="getValue(construction, 'cooling_type')"
              @input="setValue(construction, 'cooling_type', $event)"
            ></cooling-type>
          </v-col>
          <v-col cols="3">
            <cooling-subtype
              :readonly="isReadOnly()"
              label="Cooling Subtype"
              :value="getValue(construction, 'cooling_subtype')"
              @input="setValue(construction, 'cooling_subtype', $event)"
            ></cooling-subtype>
          </v-col>
          <v-col cols="3">
            <cooling-unit-owner
              :readonly="isReadOnly()"
              label="Cooling unit owner"
              :value="getValue(construction, 'cooling_unit_owner')"
              @input="setValue(construction, 'cooling_unit_owner', $event)"
            >
            </cooling-unit-owner>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <s-textarea
              :readonly="isReadOnly()"
              label="Cooling comments"
              :value="getValue(construction, 'cooling_comments')"
              @input="setValue(construction, 'cooling_comments', $event)"
            ></s-textarea>
          </v-col>
          <v-col cols="3">
            <fance
              :readonly="isReadOnly()"
              label="Fance installed"
              :value="getValue(construction, 'fance_installed')"
              @input="setValue(construction, 'fance_installed', $event)"
            ></fance>
          </v-col>
          <v-col cols="3">
            <s-textarea
              :readonly="isReadOnly()"
              label="Fance comments"
              :value="getValue(construction, 'fance_comments')"
              @input="setValue(construction, 'fance_comments', $event)"
            ></s-textarea>
          </v-col>
          <v-col cols="3">
            <generator-socket
              :readonly="isReadOnly()"
              label="Generator socket"
              :value="getValue(construction, 'generator_socket')"
              @input="setValue(construction, 'generator_socket', $event)"
            ></generator-socket>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <generator-permanent
              :readonly="isReadOnly()"
              label="Generator, Permanent"
              :value="getValue(construction, 'generator_permanent')"
              @input="setValue(construction, 'generator_permanent', $event)"
            ></generator-permanent>
          </v-col>
          <v-col cols="3">
            <generator-possibility
              :readonly="isReadOnly()"
              label="Generator, possibility to use"
              :value="getValue(construction, 'generator_possibility_to_use')"
              @input="setValue(construction, 'generator_possibility_to_use', $event)"
            ></generator-possibility>
          </v-col>
          <v-col cols="3">
            <s-textarea
              :readonly="isReadOnly()"
              label="Generator comments"
              :value="getValue(construction, 'generator_comments')"
              @input="setValue(construction, 'generator_comments', $event)"
            ></s-textarea>
          </v-col>
          <v-col cols="3">
            <generator-backup
              :readonly="isReadOnly()"
              label="Generator backup, by OIV"
              :value="getValue(construction, 'generator_backup')"
              @input="setValue(construction, 'generator_backup', $event)"
            ></generator-backup>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              label="DC backup, by OIV"
              :value="getValue(construction, 'dc_backup')"
              @input="setValue(construction, 'dc_backup', $event)"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Electrical installation check"
              :value="getValue(construction, 'electrical_installation_check')"
              @input="setValue(construction, 'electrical_installation_check', $event)"
            />
          </v-col>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Grounding system check"
              :value="getValue(construction, 'grounding_system_check')"
              @input="setValue(construction, 'grounding_system_check', $event)"
            />
          </v-col>
          <v-col cols="3">
            <mowing-grass
              :readonly="isReadOnly()"
              label="Mowing grass"
              :value="getValue(construction, 'mowing_grass')"
              @input="setValue(construction, 'mowing_grass', $event)"
            >
            </mowing-grass>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <air-condition-preventive-cleaning
              :readonly="isReadOnly()"
              label="Air Condition preventive cleaning by FO"
              :value="getValue(construction, 'air_condition_preventive_cleaning_by_fo')"
              @input="setValue(construction, 'air_condition_preventive_cleaning_by_fo', $event)"
            ></air-condition-preventive-cleaning>
          </v-col>
        </v-row>
      </v-form>
      <h2>Power agreements</h2>
      <power-agreements
        v-if="active"
        :site="site"
      ></power-agreements>
      <empty-space />
      <h2>Contracts</h2>
      <contracts
        :force-read-only="true"
        v-if="active"
        :site="site"
      ></contracts>
      <empty-space />
      <form-actions
        v-if="!isReadOnly()"
        :saved="saved"
        v-on:saveData="saveData"
      ></form-actions>
    </v-container>
  </permissions-view>
</template>

<script>
  import ResponsiblePersonConstruction from '@/components/codelist/ResponsiblePersonConstruction'
  import ReactivitMixin from '@/mixins/Reactivity'
  import PermissionsMixin from '@/mixins/Permissions'
  import CWSubcontractor from '@/components/codelist/CWSubcontractor'
  import CWSupervisor from '@/components/codelist/CWSupervisor'
  import SwitchButton from '@/components/SwitchButton'
  import ConstructionSubtype from '@/components/codelist/ConstructionSubtype'
  import EquipmentSpaceType from '@/components/codelist/EquipmentSpaceType'
  import EquipmentSpaceSubtype from '@/components/codelist/EquipmentSpaceSubtype'
  import CoolingType from '@/components/codelist/CoolingType'
  import CoolingSubtype from '@/components/codelist/CoolingSubtype'
  import CoolingUnitOwner from '@/components/codelist/CoolingUnitOwner'
  import STextarea from '@/components/Textarea'
  import Fance from '@/components/codelist/Fance'
  import GeneratorSocket from '@/components/codelist/GeneratorSocket'
  import Generator from '@/components/codelist/Generator'
  import TextField from '@/components/TextField'
  import CollapsibleSection from '@/components/CollapsibleSection'
  import FormActions from '@/components/FormActions'
  import SiteConstructionService from '@/services/site-construction'
  import SiteLocationService from '@/services/site-location'
  import ConstructionType from '@/components/codelist/ConstructionType'
  import DatePicker from '@/components/DatePicker'
  import PermissionsView from '@/components/PermissionsView'
  import MowingGrass from '@/components/codelist/MowingGrass'
  import AirConditionPreventiveCleaning from '@/components/codelist/AirConditionPreventiveCleaning'
  import EmptySpace from '@/components/EmptySpace'
  import PowerAgreements from '@/views/sites/sections/construction/PowerAgreements'
  import Contracts from '@/views/sites/sections/contract/Contracts'
  import DisplayField from '@/components/DisplayField'
  import GeneratorPermanent from '@/components/codelist/GeneratorPermanent'
  import GeneratorPossibility from '@/components/codelist/GeneratorPossibility'
  import GeneratorBackup from '@/components/codelist/GeneratorBackup'

  export default {
    name: 'Construction',
    mixins: [
      ReactivitMixin,
      PermissionsMixin,
    ],
    components: { GeneratorBackup, GeneratorPossibility, GeneratorPermanent, DisplayField, Contracts, PowerAgreements, EmptySpace, AirConditionPreventiveCleaning, MowingGrass, PermissionsView, DatePicker, ConstructionType, FormActions, CollapsibleSection, TextField, Generator, GeneratorSocket, Fance, STextarea, CoolingUnitOwner, CoolingSubtype, CoolingType, EquipmentSpaceSubtype, EquipmentSpaceType, ConstructionSubtype, SwitchButton, CWSupervisor, CWSubcontractor, ResponsiblePersonConstruction },
    props: {
      site: {
        default: null,
      },
      active: {
        default: false,
      },
    },
    data () {
      return {
        loading: false,
        saved: false,
        construction: null,
        location: null,
        section: 'construction',
      }
    },
    watch: {
      active: function (newValue, oldValue) {
        if (newValue === true && oldValue === false) {
          this.fetchData()
        }
      },
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        this.loading = true
        const ls = new SiteConstructionService(this.site.id)
        ls.getSingle().then((response) => {
          this.construction = response.data.data
          if (Array.isArray(this.construction)) {
            this.construction = {}
          }
          this.fetchLocationData().finally(() => {
            this.loading = false
          })
        })
      },
      fetchLocationData () {
        const scs = new SiteLocationService(this.site.id)
        return scs.getSingle().then((response) => {
          this.location = response.data.data
        })
      },
      saveData () {
        this.saved = false
        if (this.valid) {
          this.loading = true
          const ls = new SiteConstructionService(this.site.id)
          ls.post(this.construction).then((response) => {
            this.saved = true
          }).finally(() => {
            this.loading = false
          })
        }
      },
    },
  }
</script>

<style scoped>

</style>
